export type Debounced<T extends unknown[]> = ((...args: T) => void) & {
    cancel: () => void;
};

export function debounce<T extends unknown[]>(
    fn: (...args: T) => void,
    waitMs: number,
): Debounced<T> {
    let id: ReturnType<typeof setTimeout> | undefined;

    const d = ((...args: T) => {
        if (id !== undefined) {
            clearTimeout(id);
        }
        id = setTimeout(() => {
            id = undefined;
            fn(...args);
        }, waitMs);
    }) as Debounced<T>;

    d.cancel = () => {
        if (id !== undefined) {
            clearTimeout(id);
            id = undefined;
        }
    };

    return d;
}
